/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');
const sorAddressForm = require('./sorAddressForm');
const sorProduct = require('./sorProduct');

const orderViewOptions = {
  draggable: false,
  resizable: false,
  dialogClass: 'smart-order-refill-modal',
  autoOpen: true,
  modal: true,
  width: '43.75rem',
  title: typeof SmartOrderRefillSettings !== 'undefined' ? SmartOrderRefillSettings.Resources.SOR_DIALOG_ORDER : '',
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal
  }
};

const initOrderView = function () {
  $('.order.view').on('click', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      const $orderList = $(this).closest('.subscriptionOrders');
      if ($orderList.hasClass('sor-loader-host')) {
        return;
      }
      // lock the whole order list until the modal is visible
      sorHelpers.sorLoader.start($orderList);
      const url = $(this).attr('data-link');
      const $container = sorHelpers.sorModal.createContainer('#orderview');

      $container.load(url, function (response, status) {
        if (status === 'error') {
          sorHelpers.sorLoader.stop($orderList);
          return;
        }
        sorHelpers.sorCharLimitation.limitCharacters();
        sorHelpers.sorModal.createModal($container, orderViewOptions);
        sorHelpers.sorModal.onShown($container, function () {
          sorHelpers.sorLoader.stop($orderList);
        });
        sorProduct.refreshSorProductOosAlertsIn($container);
        sorAddressForm.initAddressChangeForm('#orderview', url);
        sorHelpers.sorMultiPack.initMultiPackEvents();
      });
    }
  });
};

module.exports = {
  initOrderView: initOrderView
};
